import {Request, RequestStatus} from "../../data-access/api-folders/Folder";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export interface RequestData {
  requests: Request[];
  requestStatuses: RequestStatus[];
  requestPage: number;
  requestHasNext: boolean;
  error?: unknown;
}

export type RequestState = RequestData;

function createInitialState(): RequestState {
  return {
    requests: [],
    requestStatuses: [],
    requestPage: 0,
    requestHasNext: true,
    error: undefined
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'request'
})
export class RequestStore extends Store<RequestState> {
  constructor() {
    super(createInitialState());
  }
}
